<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/03_Parchi-Riserve/03e_ValliCupe_Cascate.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Riserva naturale Valli Cupe</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Riserva naturale Valli Cupe</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Definita dal naturalista belga John Bouquet “Il segreto meglio custodito d’Europa” la Riserva Naturale Regionale Valli Cupe 
            si estende per 650 ettari ed è situata nella parte meridionale della Sila piccola, non distante dal Monte Gariglione, 
            con approdo nel paese di Sersale. Questa Riserva offre spettacoli di natura unici tra canyon e sentieri di rara bellezza, 
            punteggiati da gole, canyon, cascate e monoliti, senza dimenticare la presenza di antichi monasteri basiliani e siti archeologici. 
            Creata nel 2016, la Riserva Naturale Regionale Valli Cupe punta a promuovere un turismo ecosostenibile e a diffondere la conoscenza 
            di un immenso patrimonio floristico e faunistico, di habitat selvaggi e per certi versi ancora inesplorati. 
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>